<div class="flex items-center justify-center min-h-screen bg-gray-100"> 
    <h1 class="text-2xl font-bold text-center mb-6 text-gray-800">
      {{"REDIRECT_LOGIN" | translate}}
    </h1>
</div>
